module.exports = __webpack_public_path__ + "img/14.f21b2408.png";